/**
 * @generated SignedSource<<eea6526442155b2b14ad79780c650254>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSignupSummaryQuery$variables = {
  eventID: string;
  memberId?: string | null | undefined;
  patronLoyalty: boolean;
  signUpId: string;
};
export type EventSignupSummaryQuery$data = {
  readonly event: {
    readonly __typename: "Event";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryContent_event">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly signUp: {
    readonly __typename: "EventSignUp";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EventSignupSummaryContent_signUp">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type EventSignupSummaryQuery = {
  response: EventSignupSummaryQuery$data;
  variables: EventSignupSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patronLoyalty"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signUpId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventID"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signUpId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prePaymentRequirement",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEventPrePaymentEnabled",
  "storageKey": null
},
v11 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singular",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryChargeType",
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberControl",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDescription",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "EventRegistrationChargeType",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ChargeRuleSet",
      "kind": "LinkedField",
      "name": "chargeRuleSet",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ChargeRuleConnection",
          "kind": "LinkedField",
          "name": "chargeRules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChargeRuleEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ChargeRule",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "duration",
                      "storageKey": null
                    },
                    (v18/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billingId",
                      "storageKey": null
                    },
                    (v19/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelDeadlineAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prompt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSignUpWindow",
  "kind": "LinkedField",
  "name": "signUpWindow",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitlistIndex",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkedIn",
  "storageKey": null
},
v30 = {
  "alias": "memberOwnerId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v35 = [
  (v6/*: any*/)
],
v36 = {
  "kind": "InlineFragment",
  "selections": (v35/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "payingMember",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/)
  ],
  "type": "MemberEventRegistration",
  "abstractKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownRegistrantDisplayName",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "payingCustomer",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "phoneNumber",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nationalNumber",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v43 = [
  (v42/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "GOLF"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "departmentMemberProfiles",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ghinNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "GolfMemberProfile",
        "abstractKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
  }
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "booleanValue",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stringValue",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "TransportationType",
  "kind": "LinkedField",
  "name": "transportationType",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSignUpWindowChargesConnection",
  "kind": "LinkedField",
  "name": "charges",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpWindowChargesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "staffControl",
          "storageKey": null
        },
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v50 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v51 = [
  (v42/*: any*/),
  (v44/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminologyOne",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminologyOther",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSignupSummaryQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSignupSummaryContent_event"
              }
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "signUp",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "patronLoyalty",
                    "variableName": "patronLoyalty"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "EventSignupSummaryContent_signUp"
              }
            ],
            "type": "EventSignUp",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EventSignupSummaryQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unknownGuestsAllowed",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSeries",
                "kind": "LinkedField",
                "name": "eventSeries",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "supportsPublic",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "logoImage",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClubCopyOverrides",
                            "kind": "LinkedField",
                            "name": "copyOverrides",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NounOverride",
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "eventPlayer",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plural",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "enabled",
                            "value": true
                          }
                        ],
                        "concreteType": "TransportationTypeConnection",
                        "kind": "LinkedField",
                        "name": "transportationTypes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TransportationTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TransportationType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "code",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "transportationTypes(enabled:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxGuestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxMemberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minMemberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minGuestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberSignUpProxyAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "kind": "ScalarField",
                "name": "accessStatusForClient",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowChargesConnection",
                    "kind": "LinkedField",
                    "name": "charges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindowChargesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowedGroupSizes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spotsAvailable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWaitlist",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormConfiguration",
                "kind": "LinkedField",
                "name": "formConfiguration",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormQuestionConfigurationConnection",
                    "kind": "LinkedField",
                    "name": "formQuestionConfigurations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormQuestionConfigurationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormQuestionConfiguration",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "guestVisibility",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "memberVisibility",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "target",
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "placeholder",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "EventSignUp",
                "kind": "LinkedField",
                "name": "signUpForClient",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v6/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "ownerClient",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationConnection",
                    "kind": "LinkedField",
                    "name": "registrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventRegistrationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v23/*: any*/),
                              (v37/*: any*/),
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v38/*: any*/),
                                  (v40/*: any*/)
                                ],
                                "type": "GuestEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v40/*: any*/)
                                ],
                                "type": "CustomerEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationChargeType",
                                "kind": "LinkedField",
                                "name": "primaryChargeType",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChargeRuleSet",
                                    "kind": "LinkedField",
                                    "name": "chargeRuleSet",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "registrant",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v43/*: any*/),
                                    "type": "Member",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v43/*: any*/),
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  (v44/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventFormResponseConnection",
                                "kind": "LinkedField",
                                "name": "formResponses",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventFormResponseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventFormResponse",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          (v47/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FormQuestionConfiguration",
                                            "kind": "LinkedField",
                                            "name": "questionConfiguration",
                                            "plural": false,
                                            "selections": [
                                              (v24/*: any*/),
                                              (v6/*: any*/),
                                              (v23/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "kind": "ScalarField",
                "name": "signUpStatusForClient",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberHoldsAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSignUpWindowConnection",
                "kind": "LinkedField",
                "name": "signUpWindows",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindow",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancelDeadlineDaysAhead",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancelDeadlineTime",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRegistrationChargeTypeConnection",
                "kind": "LinkedField",
                "name": "primaryRegistrationChargeTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationChargeTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "eligibleWindowsForCharges",
                "args": null,
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  (v48/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "signUp",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v28/*: any*/),
              (v49/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": (v50/*: any*/),
                "concreteType": "EventRegistrationConnection",
                "kind": "LinkedField",
                "name": "registrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationChargeType",
                            "kind": "LinkedField",
                            "name": "primaryChargeType",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ChargeRuleSet",
                                "kind": "LinkedField",
                                "name": "chargeRuleSet",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 1
                                      }
                                    ],
                                    "concreteType": "ChargeRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "chargeRules",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChargeRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChargeRule",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              (v18/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "chargeRules(first:1)"
                                  },
                                  (v6/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v38/*: any*/)
                            ],
                            "type": "GuestEventRegistration",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/)
                            ],
                            "type": "CustomerEventRegistration",
                            "abstractKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "registrant",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v34/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v51/*: any*/),
                                "type": "Member",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v51/*: any*/),
                                "type": "Customer",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v50/*: any*/),
                            "concreteType": "EventFormResponseConnection",
                            "kind": "LinkedField",
                            "name": "formResponses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventFormResponseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventFormResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FormQuestionConfiguration",
                                        "kind": "LinkedField",
                                        "name": "questionConfiguration",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v23/*: any*/),
                                          (v22/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v47/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "formResponses(first:50)"
                          },
                          (v37/*: any*/),
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "registrations(first:50)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "active",
                    "value": true
                  }
                ],
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v49/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTaxes",
                            "storageKey": null
                          },
                          {
                            "condition": "patronLoyalty",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderAvailableLoyaltyRewards",
                                "kind": "LinkedField",
                                "name": "availableLoyaltyRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "balance",
                                    "storageKey": null
                                  },
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderLoyaltyRewardTier",
                                    "kind": "LinkedField",
                                    "name": "rewardTiers",
                                    "plural": true,
                                    "selections": [
                                      (v49/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SquareLoyaltyRewardTier",
                                        "kind": "LinkedField",
                                        "name": "rewardTier",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v9/*: any*/),
                                          (v54/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderLoyaltyEnrollmentOffer",
                                "kind": "LinkedField",
                                "name": "loyaltyEnrollmentOffer",
                                "plural": false,
                                "selections": [
                                  (v54/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Customer",
                                "kind": "LinkedField",
                                "name": "orderOwner",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SquareLoyaltyAccount",
                                    "kind": "LinkedField",
                                    "name": "squareLoyaltyAccount",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SquareLoyaltyAccountExpiringPointDeadline",
                                        "kind": "LinkedField",
                                        "name": "expiringPointDeadlines",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v54/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "expiresAt",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "timeZone",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SquareLoyaltyReward",
                                "kind": "LinkedField",
                                "name": "squareLoyaltyRewards",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v54/*: any*/),
                                  (v49/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "loyaltyCustomerId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SquareLoyaltyAccount",
                                    "kind": "LinkedField",
                                    "name": "loyaltyAccount",
                                    "plural": false,
                                    "selections": (v35/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SquareLoyaltyRewardTier",
                                    "kind": "LinkedField",
                                    "name": "rewardTier",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalDiscount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "bookings",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalDueAfterCredits",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expectedLoyaltyPoints",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "orders(active:true)"
              },
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v13/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSeries",
                    "kind": "LinkedField",
                    "name": "eventSeries",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareCardOnFile",
                "kind": "LinkedField",
                "name": "paymentCardOnFile",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": null
              },
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "ownerClient",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v30/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v35/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v36/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "EventSignUp",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6852d715905d65acbc6d46067b4e442",
    "id": null,
    "metadata": {},
    "name": "EventSignupSummaryQuery",
    "operationKind": "query",
    "text": "query EventSignupSummaryQuery(\n  $eventID: ID!\n  $signUpId: ID!\n  $memberId: ID\n  $patronLoyalty: Boolean!\n) {\n  event: node(id: $eventID) {\n    __typename\n    ... on Event {\n      id\n      ...EventSignupSummaryContent_event\n    }\n    id\n  }\n  signUp: node(id: $signUpId) {\n    __typename\n    ... on EventSignUp {\n      id\n      ...EventSignupSummaryContent_signUp_3CuyyL\n    }\n    id\n  }\n}\n\nfragment ActionButtonsEventSignUp_event on Event {\n  ...useGetPrimaryChargeNameAndPrice_event\n  allowedGroupSizes\n  signUpWindows {\n    edges {\n      node {\n        cancelDeadlineAt\n        cancelDeadlineDaysAhead\n        cancelDeadlineTime\n        id\n      }\n    }\n  }\n}\n\nfragment AddOrEditSignUp_event on Event {\n  ...useInitializeEventSignUpProcess_event\n  ...FormStepManager_event\n  ...ActionButtonsEventSignUp_event\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment EventDetailGroupDisplay_event on Event {\n  ...useCurrentSignUp_event\n  id\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  primaryChargeType\n  memberSignUpProxyAllowed\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  duration\n                  price\n                  billingId\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventFormStep_event on Event {\n  maxGuestCount\n  maxMemberCount\n  minGuestCount\n  minMemberCount\n  eventSeries {\n    facility {\n      club {\n        copyOverrides {\n          event {\n            singular\n          }\n        }\n        id\n      }\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      transportationTypes(enabled: true) {\n        edges {\n          node {\n            id\n            code\n            customCode\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EventSignUpPrimaryChargePaymentAssignment_event on Event {\n  ...useGetPrimaryChargeNameAndPrice_event\n  memberSignUpProxyAllowed\n  prePaymentRequirement\n}\n\nfragment EventSignupSummaryActions_event on Event {\n  id\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  memberSignUpProxyAllowed\n  accessStatusForClient(clientId: $memberId)\n  prePaymentRequirement\n  eventSeries {\n    name\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventSignupSummaryActions_signUp on EventSignUp {\n  id\n  canDelete\n  status\n  waitlistIndex\n  checkedIn\n  signUpWindow {\n    cancelDeadlineAt\n    id\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n      memberOwnerId: id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n        }\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          ... on Member {\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            email\n          }\n          ... on Customer {\n            phoneNumber {\n              nationalNumber\n              id\n            }\n            email\n          }\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryContent_event on Event {\n  id\n  unknownGuestsAllowed\n  prePaymentRequirement\n  eventSeries {\n    name\n    facility {\n      isEventPrePaymentEnabled\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  ...EventSignupSummaryHeader_event\n  ...EventSignupSummaryPlayerList_event\n  ...EventSignupSummaryActions_event\n  ...useInitGroupEvent_event\n  ...useInitEventMeta_event\n  ...useInitEventForm_formQuestionConfiguration\n  ...useInitEventSignUps_event\n  ...UpdateAttendeesGroupEventsModal_event\n}\n\nfragment EventSignupSummaryContent_signUp_3CuyyL on EventSignUp {\n  id\n  canDelete\n  status\n  waitlistIndex\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n        availableLoyaltyRewards @include(if: $patronLoyalty) {\n          balance\n        }\n        loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n          points\n        }\n        orderOwner @include(if: $patronLoyalty) {\n          id\n          squareLoyaltyAccount {\n            id\n          }\n        }\n        squareLoyaltyRewards @include(if: $patronLoyalty) {\n          id\n          points\n          status\n          loyaltyCustomerId\n          loyaltyAccount {\n            id\n          }\n          rewardTier {\n            id\n            name\n          }\n        }\n        ...PatronCheckoutLoyaltyRewards_order @include(if: $patronLoyalty)\n        ...PatronCheckoutLoyaltyRewardsEnrollmentOffer_order @include(if: $patronLoyalty)\n      }\n    }\n  }\n  signUpWindow {\n    cancelDeadlineAt\n    id\n  }\n  ...EventSignupSummaryPlayerList_signUp\n  ...EventSignupSummaryTotal_signUp\n  ...EventSignupSummaryPaymentSummary_signUp_3CuyyL\n  ...EventSignupSummaryReservation_signUp_3CuyyL\n  ...EventSignupSummaryActions_signUp\n}\n\nfragment EventSignupSummaryHeader_event on Event {\n  eventSeries {\n    facility {\n      club {\n        name\n        ...ClubLogo_Club\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EventSignupSummaryPaymentSummary_signUp_3CuyyL on EventSignUp {\n  id\n  status\n  waitlistIndex\n  event {\n    id\n    prePaymentRequirement\n    eventSeries {\n      facility {\n        id\n        isEventPrePaymentEnabled\n      }\n      id\n    }\n    primaryChargeType\n  }\n  paymentCardOnFile {\n    id\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on CustomerEventRegistration {\n          payingCustomer {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n        availableLoyaltyRewards @include(if: $patronLoyalty) {\n          balance\n        }\n        loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n          points\n        }\n        orderOwner @include(if: $patronLoyalty) {\n          id\n          squareLoyaltyAccount {\n            id\n          }\n        }\n        squareLoyaltyRewards @include(if: $patronLoyalty) {\n          id\n          points\n          status\n          loyaltyCustomerId\n          loyaltyAccount {\n            id\n          }\n          rewardTier {\n            id\n            name\n          }\n        }\n        ...PatronCheckoutLoyaltyRewards_order @include(if: $patronLoyalty)\n        ...PatronCheckoutLoyaltyRewardsEnrollmentOffer_order @include(if: $patronLoyalty)\n      }\n    }\n  }\n  ...EventSignupSummaryTotal_signUp\n}\n\nfragment EventSignupSummaryPlayerList_event on Event {\n  primaryChargeType\n  eventSeries {\n    name\n    id\n  }\n}\n\nfragment EventSignupSummaryPlayerList_signUp on EventSignUp {\n  registrations(first: 50) {\n    edges {\n      node {\n        id\n        __typename\n        type\n        ... on GuestEventRegistration {\n          unknownRegistrantDisplayName\n        }\n        ... on CustomerEventRegistration {\n          unknownRegistrantDisplayName\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            displayName\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              questionConfiguration {\n                id\n                type\n                prompt\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryReservation_signUp_3CuyyL on EventSignUp {\n  id\n  status\n  waitlistIndex\n  event {\n    id\n    prePaymentRequirement\n    eventSeries {\n      facility {\n        id\n        isEventPrePaymentEnabled\n      }\n      id\n    }\n    primaryChargeType\n  }\n  paymentCardOnFile {\n    id\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        ... on MemberEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on GuestEventRegistration {\n          payingMember {\n            id\n          }\n        }\n        ... on CustomerEventRegistration {\n          payingCustomer {\n            id\n          }\n        }\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n        registrant {\n          __typename\n          id\n        }\n        formResponses(first: 50) {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n        loyaltyEnrollmentOffer @include(if: $patronLoyalty) {\n          points\n        }\n      }\n    }\n  }\n}\n\nfragment EventSignupSummaryTotal_signUp on EventSignUp {\n  status\n  event {\n    id\n    primaryChargeType\n  }\n  registrations(first: 50) {\n    edges {\n      node {\n        __typename\n        id\n        primaryChargeType {\n          id\n          chargeRuleSet {\n            displayName\n            chargeRules(first: 1) {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  orders(active: true) {\n    edges {\n      node {\n        id\n        status\n        total\n        totalTaxes\n      }\n    }\n  }\n}\n\nfragment FormStepManager_event on Event {\n  ...GroupRegistrationDisplay_event\n  ...EventFormStep_event\n  ...PrimaryChargeSelectionStep_event\n  ...EventSignUpPrimaryChargePaymentAssignment_event\n  primaryChargeType\n  prePaymentRequirement\n  spotsAvailable\n  memberSignUpProxyAllowed\n  capacityType\n  maxMemberCount\n  maxGuestCount\n  allowedGroupSizes\n}\n\nfragment GroupRegistrationDisplay_event on Event {\n  spotsAvailable\n  capacityType\n  allowedGroupSizes\n  minGuestCount\n  minMemberCount\n  maxGuestCount\n  maxMemberCount\n  memberSignUpProxyAllowed\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment PatronCheckoutLoyaltyRewardsEnrollmentOffer_order on Order {\n  loyaltyEnrollmentOffer {\n    points\n    terminologyOne\n    terminologyOther\n  }\n}\n\nfragment PatronCheckoutLoyaltyRewards_order on Order {\n  id\n  status\n  total\n  totalTaxes\n  totalDiscount\n  bookings {\n    __typename\n    id\n    totalDueAfterCredits\n  }\n  expectedLoyaltyPoints\n  orderOwner {\n    squareLoyaltyAccount {\n      expiringPointDeadlines {\n        id\n        points\n        expiresAt\n      }\n      id\n    }\n    club {\n      timeZone\n      id\n    }\n    id\n  }\n  availableLoyaltyRewards {\n    balance\n    terminologyOne\n    terminologyOther\n    rewardTiers {\n      status\n      rewardTier {\n        id\n        name\n        points\n      }\n    }\n  }\n  squareLoyaltyRewards {\n    id\n    points\n    status\n    loyaltyCustomerId\n    loyaltyAccount {\n      id\n    }\n    rewardTier {\n      id\n      name\n    }\n  }\n}\n\nfragment PrimaryChargeSelectionStep_event on Event {\n  id\n  ...useGetAllPrimaryChargeSelectionOptions_event\n  primaryChargeType\n  prePaymentRequirement\n}\n\nfragment UpdateAttendeesGroupEventsModal_event on Event {\n  id\n  signUpStatusForClient(clientId: $memberId)\n  accessStatusForClient(clientId: $memberId)\n  unknownGuestsAllowed\n  memberHoldsAllowed\n  capacityType\n  spotsAvailable\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      copyOverrides {\n        eventPlayer {\n          singular\n          plural\n        }\n      }\n      id\n    }\n    id\n  }\n  signUpWindows {\n    edges {\n      node {\n        cancelDeadlineAt\n        cancelDeadlineDaysAhead\n        cancelDeadlineTime\n        id\n      }\n    }\n  }\n  primaryRegistrationChargeTypes {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...EventDetailGroupDisplay_event\n  ...useInitEventSignUpPrimaryChargeInfo_event\n  ...AddOrEditSignUp_event\n}\n\nfragment useCurrentSignUp_event on Event {\n  signUpForClient(clientId: $memberId) {\n    signUpWindow {\n      cancelDeadlineAt\n      id\n    }\n    waitlistIndex\n    id\n    canDelete\n    checkedIn\n    ownerClient {\n      __typename\n      ... on Member {\n        id\n        memberOwnerId: id\n        firstName\n        lastName\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Customer {\n        id\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    registrations {\n      edges {\n        node {\n          __typename\n          id\n          type\n          index\n          ... on MemberEventRegistration {\n            payingMember {\n              id\n            }\n          }\n          ... on GuestEventRegistration {\n            payingMember {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          ... on CustomerEventRegistration {\n            payingCustomer {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          primaryChargeType {\n            id\n            chargeRuleSet {\n              displayName\n              displayDescription\n              id\n            }\n          }\n          registrant {\n            __typename\n            id\n            firstName\n            lastName\n            profileImage {\n              publicId: renderingKey\n            }\n            ... on Member {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            ... on Customer {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            email\n          }\n          formResponses {\n            edges {\n              node {\n                id\n                booleanValue\n                stringValue\n                transportationType {\n                  id\n                }\n                questionConfiguration {\n                  enabled\n                  id\n                  type\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useGetAllPrimaryChargeSelectionOptions_event on Event {\n  signUpWindows {\n    edges {\n      node {\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                id\n                displayName\n                displayDescription\n                chargeRules {\n                  edges {\n                    node {\n                      price\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  eligibleWindowsForCharges: clientEligibleSignUpWindows {\n    charges {\n      edges {\n        memberControl\n        staffControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useGetPrimaryChargeNameAndPrice_event on Event {\n  signUpWindows {\n    edges {\n      node {\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                id\n                displayName\n                chargeRules {\n                  edges {\n                    node {\n                      price\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  eligibleWindowsForCharges: clientEligibleSignUpWindows {\n    charges {\n      edges {\n        memberControl\n        staffControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            chargeRules {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useInitEventForm_formQuestionConfiguration on Event {\n  formConfiguration {\n    id\n    formQuestionConfigurations {\n      edges {\n        node {\n          id\n          prompt\n          type\n          guestVisibility\n          memberVisibility\n          values\n          enabled\n          shortName\n          target\n        }\n      }\n    }\n  }\n}\n\nfragment useInitEventMeta_event on Event {\n  id\n  capacity\n  spotsAvailable\n  hasWaitlist\n  accessStatusForClient(clientId: $memberId)\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    cancelDeadlineAt\n    id\n  }\n  memberSignUpProxyAllowed\n}\n\nfragment useInitEventSignUpPrimaryChargeInfo_event on Event {\n  maxMemberCount\n  minMemberCount\n  maxGuestCount\n  minGuestCount\n  primaryChargeType\n  primaryRegistrationChargeTypes {\n    edges {\n      node {\n        chargeRuleSet {\n          id\n          displayName\n          displayDescription\n          chargeRules {\n            edges {\n              node {\n                id\n                duration\n                price\n                billingId\n                description\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useInitEventSignUps_event on Event {\n  memberSignUpProxyAllowed\n  ...useCurrentSignUp_event\n  signUpStatusForClient(clientId: $memberId)\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useInitGroupEvent_event on Event {\n  maxMemberCount\n  minMemberCount\n  maxGuestCount\n  minGuestCount\n  allowedGroupSizes\n}\n\nfragment useInitializeEventSignUpProcess_event on Event {\n  id\n  maxGuestCount\n  maxMemberCount\n  minGuestCount\n  minMemberCount\n  allowedGroupSizes\n  memberSignUpProxyAllowed\n  hasWaitlist\n  capacityType\n  spotsAvailable\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  formConfiguration {\n    id\n    formQuestionConfigurations {\n      count\n      edges {\n        node {\n          id\n          enabled\n          guestVisibility\n          memberVisibility\n          description\n          placeholder\n          prompt\n          shortName\n          target\n          type\n          values\n        }\n      }\n    }\n  }\n  primaryChargeType\n  primaryRegistrationChargeTypes {\n    count\n  }\n  signUpWindows {\n    edges {\n      node {\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                id\n                displayName\n                displayDescription\n                chargeRules {\n                  edges {\n                    node {\n                      id\n                      duration\n                      price\n                      billingId\n                      description\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  eligibleWindowsForCharges: clientEligibleSignUpWindows {\n    charges {\n      edges {\n        memberControl\n        staffControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  duration\n                  price\n                  billingId\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d826579090c3de4df47df6229c1535e8";

export default node;
